import { InitializeTokenResponse } from "@/models/authentication/initializeToken";
import { LogOutIdentResponse } from "@/models/authentication/logOutIdentResponse";
import { RefreshTokenResponse } from "@/models/authentication/refreshTokenResponse";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { getInitializeTokenSet, getLogOutIdent, getRefreshTokenSet } from "../sets/authenticationSet";

const refreshTokenAdapter = createEntityAdapter({
  selectId: (item: RefreshTokenResponse) => item.access_token,
});
let authenticationState = refreshTokenAdapter.getInitialState();
authenticationState = refreshTokenAdapter.setOne(authenticationState, getRefreshTokenSet);

const initializeTokenAdapter = createEntityAdapter({
  selectId: (item: InitializeTokenResponse) => item.initialToken.access_token,
});
let initializeTokenState = initializeTokenAdapter.getInitialState();
initializeTokenState = initializeTokenAdapter.setOne(initializeTokenState, getInitializeTokenSet);

const logOutIdentAdapter = createEntityAdapter({
  selectId: (item: LogOutIdentResponse) => item.redirectUrl,
});
let logOutIdentState = logOutIdentAdapter.getInitialState();
logOutIdentState = logOutIdentAdapter.setOne(logOutIdentState, getLogOutIdent);

export const authenticationHandlers = [
  http.post(`${envSettings.UTILS_API_URL}/${envSettings.REFRESH_TOKEN}`, async () => {
    await delay(50);
    return HttpResponse.json(Object.values(authenticationState.entities)[0], { status: 200 });
  }),

  http.post(`${envSettings.UTILS_API_URL}/${envSettings.JWT}`, async () => {
    await delay(50);
    return HttpResponse.json(Object.values(initializeTokenState.entities)[0], { status: 200 });
  }),

  http.get(`${envSettings.UTILS_API_URL}/${envSettings.INITIALIZE_TOKEN_PREF}`, async () => {
    await delay(50);
    return HttpResponse.json(Object.values(initializeTokenState.entities)[0], { status: 200 });
  }),

  http.get(`${envSettings.UTILS_API_URL}/${envSettings.LOG_OUT_IDENT}`, async () => {
    await delay(50);
    return HttpResponse.json(Object.values(logOutIdentState.entities)[0], { status: 200 });
  }),
];
